import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import config from 'react-global-configuration';
import { useHistory } from 'react-router-dom';
import * as qs from 'qs';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import SearchKitVNL from '../SearchKit';

import './style.scss';

import { DOMAIN_VNL } from '../../config/constants';
import { SelectFacet } from '../SearchKit/SelectFacet';
import { SearchFacets } from '../SearchKit/SearchFacets';

import * as query from './query.graphql';

const HomepageSearchLazy = ({ entity }) => {
  const history = useHistory();
  const [defaultFilters, setDefaultFilters] = useState(null);
  const [previousFilters, setPreviousFilters] = useState(null);
  const [filters, setFilters] = useState(null);
  const [canSearch, setCanSearch] = useState(false);

  const ctaClasses = classNames(
    'NodeHomePage__wizard__cta',
    'Button--primary',
    {
      disabled: !canSearch,
    });

  useEffect(() => {
    if (!defaultFilters) {
      setDefaultFilters(filters);
    }
    if (filters && filters !== previousFilters) {
      if (previousFilters) {
        setCanSearch(true);
      }
      setPreviousFilters(filters);
    }
  }, [filters, defaultFilters, previousFilters]);

  useEffect(() => {
    if (previousFilters === defaultFilters) {
      setCanSearch(false);
    }
  }, [previousFilters, defaultFilters]);

  const onChange = (newFacets, newFilters) => {
    if (newFilters) {
      setFilters(qs.stringify(newFilters));
    }
  };

  const onClick = () => {
    if (canSearch) {
      history.push({
        pathname: config.get('CURRENT_DOMAIN') === DOMAIN_VNL ? '/kennisaanbod' : '/adviezen',
        search: `?filters=${filters}`,
      });
    }
  };

  const CustomFacets = [SelectFacet, SearchFacets];

  return (
    <div className="NodeHomePage__wizard">
      <h2>{entity.getIn(['field_homepage_wizard_title', 0, 'value'])}</h2>
      <p>{entity.getIn(['field_homepage_wizard_subtitle', 0, 'value'])}</p>
      <div className="NodeHomePage__wizard__filters">
        <SearchKitVNL
          query={query}
          pageSize={1}
        >
          {
            (data, loading) => (
              <>
                {data && (
                  <SearchFacets data={data.wizard} loading={loading} facets={CustomFacets} onChange={onChange} />
                )}
              </>
            )
          }
        </SearchKitVNL>
      </div>
      <Button className={ctaClasses} onClick={onClick}>
        Toon mijn resultaten <i className="icon icon-arrow-right icon-variant-2" />
      </Button>
    </div>
  );
};

export default HomepageSearchLazy;
